import { selectRecuperarDocumentos } from '@/features/enviar-documentos/entities/select-recuperar-documentos'
import { GetDocumentosDoCompradorDaPropostaService } from '@/features/enviar-documentos/services/get-documentos-comprador-proposta'
import { propostaKeys } from '@/features/proposta/utils'

export const recuperarDocumentosPessoaDaPropostaQuery = (numeroDaProposta: string, pessoaId: string) => ({
  gcTime: 0,
  staleTime: 0,
  queryKey: propostaKeys.documentosPessoa(numeroDaProposta, pessoaId),
  queryFn: async () =>
    new GetDocumentosDoCompradorDaPropostaService()
      .execute(numeroDaProposta, pessoaId)
      .then((response) => response.data),
  select: selectRecuperarDocumentos,
})
